"use strict";
const bundle_app = document.querySelector('.bundle__app');
const numeric = ['First', 'Second', 'Third', 'Final'];
const personalize_btn = document.querySelector('.btn--personalize');
const cancel_btn = document.querySelector('.btn--personalize-cancel');
const qty_btns = document.querySelectorAll('.qty__btn');
let total_bundle_items = 1;
let current_l3_steps = 0;

qty_btns.forEach(qty_btn => qty_btn.addEventListener('click', e => {
	const input = e.target.closest('.qty__container').querySelector('.qty__input');
	if(!input) return;

	let val = Number(input.value);
	if(isNaN(val)) {
		val = 1;
	} else if(e.target.classList.contains('qty__btn--less')) {
		if(val > 1) val--;
	} else {
		val++;
	}

	input.value = val;
}));

if(personalize_btn) personalize_btn.addEventListener('click', () => {
	document.body.classList.add('bundle-config-active');

	bundle_app.scrollIntoView({behavior: 'smooth'});

	// Get current variant id
	const selected_variant_id = document.querySelector('.product-detail__detail [name="id"]').value;
	
	// Get input that matches this variant id
	const selected_item_input = document.querySelector(`.bundle__input--product[value="${selected_variant_id}"]`);
	
	if(selected_item_input) {
		selected_item_input.checked = true;

		current_l3_steps++;
		bundle_app.style.setProperty('--current-l3-steps', current_l3_steps);

		setBundlePreviewImage(selected_item_input);

		const conf = selected_item_input.closest('.bundle__step--config');
		conf.style.setProperty('--step-l3', 2);
	}
});

if(cancel_btn) cancel_btn.addEventListener('click', () => document.body.classList.remove('bundle-config-active'));

function get_element_index(elem){
    let i = 0;
    while((elem = elem.previousElementSibling) != null) ++i;
    return i;
}

function bundle__number_select() {
	let total_bundle_items = Number(bundle_app.querySelector('[name="bundle-number"]:checked').value);	
	if(isNaN(total_bundle_items)) total_bundle_items = 1;

	const bundle_qty_inputs = document.querySelectorAll('.bundle__deal .qty__input');
	bundle_qty_inputs.forEach(bundle_qty_input => bundle_qty_input.value = total_bundle_items);

	bundle_app.style.setProperty('--total-items', total_bundle_items);

	const current_conf = bundle_app.querySelectorAll('.bundle__step--config');
	const conf_container = current_conf[0].closest('.bundle__config-container');
	if(current_conf.length > total_bundle_items) {
		for(let i = current_conf.length; i > total_bundle_items; i--) {
			current_conf[i - 1].remove();
		}
	} else if(current_conf.length < total_bundle_items) {
		for(let i = current_conf.length; i < total_bundle_items; i++) {
			const clone = current_conf[current_conf.length - 1].cloneNode(true);

			clone.style.setProperty('--step-l3', 1);

			clone.querySelector('.current-qty').textContent = i + 1;
			clone.querySelector('.current-qty-text').textContent = numeric[i];

			clone.querySelectorAll('[data-name-base]').forEach(element_to_rename => {
				element_to_rename.setAttribute('name', `${element_to_rename.getAttribute('data-name-base')}-${i + 1}`);
			});

			conf_container.appendChild(clone);
		}
	}

	conf_container.querySelectorAll('.total-qty').forEach(span => span.textContent = total_bundle_items);
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

let stepTimeoutWaiting = false;
async function bundle__nav_click(e, next) {
	if(stepTimeoutWaiting) return;

	stepTimeoutWaiting = true;
	setTimeout(() => {
		stepTimeoutWaiting = false;
	}, 500);

	// Update number of bundle items
	if(next && e.target.classList.contains('next-step-button--qty'))
		bundle__number_select();

	let current_step = e.target.closest('.bundle__step');
	let next_step, step, steps_container, level;

	bundle_app.scrollIntoView({behavior: 'smooth'});
	await sleep(100);

	// Switch step
	if(next) {
		next_step = current_step.nextElementSibling;

		if(!next_step) { // No steps on this level. Go up
			current_step = current_step.parentElement.closest('.bundle__step');
			next_step = current_step.nextElementSibling;
		}
		
		if(current_step && !next_step) { // No steps on this level. Go up
			current_step = current_step.parentElement.closest('.bundle__step');
		}

		if(!current_step) {
			console.log('Error. No next step.');
			return;
		}

		steps_container = current_step.parentElement.closest('.bundle__steps');

		level = 1;
		if(steps_container.getAttribute('data-level') == '2') {
			level = 2;
		} else if(steps_container.getAttribute('data-level') == '3') {
			level = 3;
		}
	
		step = Number(steps_container.style.getPropertyValue(`--step-l${level}`));
	} else {
		steps_container = e.target.closest('.bundle__steps');
		level = steps_container.getAttribute('data-level');
		step = steps_container.style.getPropertyValue(`--step-l${level}`);
	
		if(step <= 1) {
			steps_container = steps_container.parentElement.closest('.bundle__steps');
			level = steps_container.getAttribute('data-level');
			step = steps_container.style.getPropertyValue(`--step-l${level}`);
		}
	
		if(step <= 1) {
			steps_container = steps_container.parentElement.closest('.bundle__steps');
			level = steps_container.getAttribute('data-level');
			step = steps_container.style.getPropertyValue(`--step-l${level}`);
		}
	
		if(level == 3) {
			current_l3_steps--;
			bundle_app.style.setProperty('--current-l3-steps', current_l3_steps);
		}
	}

	if(!step) step = 1;

	if(next) step++;
	else step--;

	bundle_app.querySelectorAll('.bundle__step--current').forEach(el => el.classList.remove('bundle__step--current'));

	if(level == 1) {
		console.log("??");
		let current_1 = steps_container.querySelector(`:scope > .bundle__step:nth-child(${step})`);
		if(current_1) {
			if(current_1.classList.contains('bundle__step--last')) {
				current_1.classList.add('bundle__step--current');
			}

			let current_2 = current_1.querySelector('.bundle__step[data-level="3"]:first-child');

			if(current_2) {
				let step3 = Number(current_2.style.getPropertyValue(`--step-l3`));
				if(isNaN(step3) || !step3) step3 = 1;

				let current_3 = current_2.querySelectorAll(`:scope > .bundle__slider > .bundle__step:nth-child(${step3})`);
				current_3.forEach(c_3 => c_3.classList.add('bundle__step--current'));
			}
		}
	}

	if(level == 2) {
		let current_2 = steps_container.querySelector(`:scope > .bundle__slider > .bundle__step:nth-child(${step})`);
		if(current_2) {
			let current_3;

			if(next) {
				current_3 = current_2.querySelectorAll(`:scope > .bundle__slider > .bundle__step:first-child`);
				current_3.forEach(c_3 => {
					c_3.classList.add('bundle__step--current');
					// const fcs = c_3.querySelector('.next-step-button');
					// if(fcs) fcs.focus();
				});
			} else {
				current_3 = current_2.querySelectorAll(':scope > .bundle__slider > .bundle__step:last-child');
				current_3.forEach(c_3 => {
					c_3.classList.add('bundle__step--current');
					// const fcs = c_3.querySelector('.next-step-button, .bundle__form');
					// if(fcs) fcs.focus();
				});
			}
		}
	}

	if(level == 3) {
		if(next) current_l3_steps++;
		else current_l3_steps--;

		bundle_app.style.setProperty('--current-l3-steps', current_l3_steps);

		steps_container.querySelectorAll(`.bundle__step:nth-child(${step})`).forEach(st => {
			st.classList.add('bundle__step--current');
			// const fcs = st.querySelector('.next-step-button, .bundle__form');
			// if(fcs) fcs.focus();
		});

		steps_container.querySelectorAll('.bundle__step-variable-height-open').forEach(el => el.classList.remove('bundle__step-variable-height-open'));

		let var_height = steps_container.querySelector(`.bundle__slider > .bundle__step:nth-child(${step}) > .bundle__step-variable-height`);
		if(var_height) var_height.classList.add('bundle__step-variable-height-open');
	}

	if(level == 1 && step == 3) {
		const preview_items = bundle_app.querySelector('.bundle__items-preview-list');
		while (preview_items.firstChild) {
			preview_items.removeChild(preview_items.lastChild);
		}

		const item_previews = bundle_app.querySelectorAll('.bundle__step--config .bundle__step--final-preview .item__preview');
		item_previews.forEach(item_preview => {
			preview_items.appendChild(item_preview.cloneNode(true));
		});
	}

	// if(level == 1 && step == 2) {
	// 	document.querySelector('.bundle__input--product:checked').closest('.bundle__item--product').click();
	// }

	// const current_form = document.querySelector('.bundle__step--current form');
	// if(current_form) {
	// 	const focusable_element = current_form.querySelector('input[type="text"], button[type="submit"], button');
	// 	if(focusable_element) focusable_element.focus();
	// }
	document.activeElement.blur();
	
	steps_container.style.setProperty(`--step-l${level}`, step);
}

if(bundle_app) bundle_app.addEventListener('submit', e => {
	if(e.target.classList.contains('bundle__form')) {
		e.preventDefault();

		bundle__nav_click(e, true);
	}
});

function setBundlePreviewImage(target) {
	const image_to_clone = target.parentElement.querySelector('.bundle__item-image img');
	const config_container = target.closest('.bundle__step--config');
	const node_exists = config_container.querySelector('.item__preview-image img');

	if(node_exists) {
		config_container.querySelectorAll('.item__preview-image').forEach(node => node.replaceChild(image_to_clone.cloneNode(true), node.querySelector('img')));
	} else {
		config_container.querySelectorAll('.item__preview-image').forEach(node => node.appendChild(image_to_clone.cloneNode(true)));
	}
}

if(bundle_app) {
	bundle_app.addEventListener('click', e => {
		if(e.target.classList.contains('next-step-button')) {
			bundle__nav_click(e, true);
		} else if(e.target.classList.contains('previous-step-button')) {
			bundle__nav_click(e, false);
		} else if(e.target.classList.contains('item__preview-edit')) {
			bundle_app.style.setProperty('--step-l1', '2');

			bundle_app.scrollIntoView({behavior: 'smooth'});
			
			bundle_app.querySelector('.bundle__steps[data-level="2"]').style.setProperty('--step-l2', get_element_index(e.target.closest('.item__preview')) + 1);

			bundle_app.querySelectorAll('.bundle__step--config[data-level="3"]').forEach(el => el.style.setProperty('--step-l3', '1'));

			bundle_app.querySelectorAll('.bundle__step--current').forEach(el => el.classList.remove('bundle__step--current'));

			bundle_app.querySelectorAll('.bundle__step--config[data-level="3"] .bundle__step:first-child').forEach(el => el.classList.add('bundle__step--current'));
		} else if(e.target.classList.contains('bundle__input--product')) { // Set product image in preview
			setBundlePreviewImage(e.target);
		} else if(e.target.classList.contains('bundle__input--icon')) { // Set icon in preview
			const item_parent = e.target.parentElement;
			const config_container = e.target.closest('.bundle__step--config');
			const existing_nodes = config_container.querySelectorAll('.item__preview-icon img');
			if(item_parent.getAttribute('data-value') == 'no-symbol') {
				if(existing_nodes.length > 0) existing_nodes.forEach(node => node.remove());
			} else {
				const image_to_clone = item_parent.querySelector('img');

				if(existing_nodes.length > 0) {
					config_container.querySelectorAll('.item__preview-icon').forEach(node => node.replaceChild(image_to_clone.cloneNode(true), node.querySelector('img')));
				} else {
					config_container.querySelectorAll('.item__preview-icon').forEach(node => node.appendChild(image_to_clone.cloneNode(true)));
				}
			}
		}
	});

	bundle_app.addEventListener('keyup', e => {
		if(e.target.classList.contains('bundle__input--name')) {
			e.target.closest('.bundle__step--config').querySelectorAll('.item__preview-text--first').forEach(node => node.textContent = e.target.value);
		} else if(e.target.classList.contains('bundle__input--last-name-phone')) {
			e.target.closest('.bundle__step--config').querySelectorAll('.item__preview-text--last').forEach(node => node.textContent = e.target.value);
		}

		if(e.target.classList.contains('bundle__input-count')) {
			e.target.closest('label').querySelector('.input__counter span').textContent = e.target.value.length;
		}
	});
}

document.querySelectorAll('.bundle__deal-add').forEach(bundle_add => bundle_add.addEventListener('click', e => {
	e.preventDefault();

	let items = [];
	
	const deal_container = e.target.closest('.bundle__deal');
	
	if(deal_container) {
		const bundle_qty = Number(deal_container.querySelector('.qty__input').value);
		if(isNaN(bundle_qty) || bundle_qty < 1) bundle_qty = 1;
		const selected_bundle_id = deal_container.querySelector('input[type="text"][name="id"], input[type="radio"][name="id"]:checked');
		
		if(selected_bundle_id) {
			items.push(
				{
					id: selected_bundle_id.value,
					quantity: bundle_qty
				}
			);
		}
	}

	document.querySelectorAll('.bundle__step--config').forEach(item => {
		const checked_icon = item.querySelector('.bundle__input--icon:checked');
		items.push(
			{
				id: item.querySelector('.bundle__input--product:checked').value,
				quantity: 1,
				properties: {
					'Name': item.querySelector('.bundle__input--name').value,
					'Last Name Or Phone Number': item.querySelector('.bundle__input--last-name-phone').value,
					'_icon': checked_icon?checked_icon.value:'',
					'Icon': checked_icon?checked_icon.getAttribute('title'):''
				}
			}
		);
	});

	let formData = {
		'items': items
	};
	
	fetch(window.Shopify.routes.root + 'cart/add.js', {
		method: 'POST',
		headers: {
		   'Content-Type': 'application/json'
		},
		body: JSON.stringify(formData)
	})
	.then(response => {
        if(!response.ok) {
            if(response.status == 422) {
                alert('Item not available!');
            }

            throw new Error(`HTTP error! status: ${response.status}`);
        }

		return response.json();
	}).then(json => {
		location.href = '/cart';
	})
	.catch((error) => {
		console.error('Error:', error);
	});
}));